import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TabNavigationWidgetV2: WidgetRegistryEntry = {
  name: "TabNavigationV2",
  configuration: () => import("./configuration").then((m) => m.TabNavigationWidgetV2Configuration),
  component: () => import("./tab-navigation-widget-v2.component").then((m) => m.TabNavigationWidgetV2Component)
};
